import type { IUser } from '@interfaces/user';

/**
 * Returns true when the stored refresh token has a known expiry in the past.
 * If expiry is missing we cannot decide client-side — leave it to the API/401 flow.
 */
export function isRefreshTokenExpired(
	user?: Pick<IUser, 'refreshTokenExpiresAt'> | null
): boolean {
	const expiresAt = user?.refreshTokenExpiresAt;
	if (!expiresAt) return false;

	const expiresMs = new Date(expiresAt).getTime();
	if (Number.isNaN(expiresMs)) return false;

	return Date.now() >= expiresMs;
}

export function resolveAccessToken(
	user?: Pick<IUser, 'token' | 'accessToken'> | null
): string | null {
	return user?.token || user?.accessToken || null;
}
